import React from "react";

import { useRegister } from "./useRegister.tsx";
import RegisterUI from "./Register.ui.tsx";

const Register: React.FC = () => {
  const RegisterProps = useRegister();

  return <RegisterUI {...RegisterProps} />;
};

export default Register;
